var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asp-home",style:(("background-image: url(" + _vm.backgroundImage + ")"))})}
var staticRenderFns = []

export { render, staticRenderFns }